import React, { useState, useEffect } from 'react';
import OtherIndustry from 'components/Core/RadioGroup/OtherIndustryRadioGroup';
import useBreakpointView from 'utils/useBreakpointView';
import RadioGroup from '..';
import { IndustryRadioGroupContainer, OtherOptionsContainer, GafOptionsContainer } from './styled';

const IndustryRadioGroup = ({
  otherOptions = [],
  otherLabel = 'Select your industry',
  otherId = 'industryTestVerticals',
  handleChange,
  dataCy,
  value,
  values,
  options = [],
  $backBtnTrigger,
  ...otherProps
}) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const allIndustries = [...options.map((x) => x.value), ...otherOptions.map((x) => x.value)];
  const isMobile = useBreakpointView(['xs', 'sm']);

  useEffect(() => {
    const setCurrentSlideHeight = (index) => {
      const currentSlide = document.querySelector(
        '.industry-radio-group-slider .industry-radio-group-slide.slide-' + index,
      );
      if (currentSlide) {
        const contentDiv = currentSlide.querySelector(':scope > div');
        if (contentDiv) {
          const contentHeight = contentDiv.offsetHeight + 40;
          currentSlide.style.height = `${contentHeight}px`;
          currentSlide.closest('.industry-radio-group-slider').style.height = `${contentHeight}px`;
        }
      }
    };

    if (isMobile) {
      setCurrentSlideHeight(currentSlide);
    }

    const modalContainer = document.querySelector(
      '.modal-marketing-form--modal .data-layer-form.form-step-0',
    );
    if (modalContainer) {
      modalContainer.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [currentSlide, isMobile]);

  useEffect(() => {
    if (value && !allIndustries.includes(value)) {
      handleChange?.(otherProps.id, '', true);
      return;
    }

    if (value !== 'Other' && values?.[otherId]) {
      delete values[otherId];
    }
    if (value !== 'Roofing' && values?.iamaGAFcertifiedcontractor) {
      delete values.iamaGAFcertifiedcontractor;
    }
    if (value === 'Roofing' && values?.iamaGAFcertifiedcontractor !== undefined) {
      setTimeout(() => {
        setCurrentSlide(2);
      }, 30);
    }
  }, [value, values]);

  useEffect(() => {
    if (currentSlide > 0) {
      if (values[otherProps.id] === 'Other') {
        handleChange?.(otherId, undefined);
      } else if (values[otherProps.id] === 'Roofing') {
        handleChange?.('iamaGAFcertifiedcontractor', undefined);
      }

      setCurrentSlide(0);

      setTimeout(() => {
        handleChange?.(otherProps.id, '', true);
      }, 0);
    }
  }, [$backBtnTrigger]);

  const onHandleChange = (id, newValue) => {
    handleChange?.(id, newValue);

    if (newValue === 'Other') {
      setCurrentSlide(1);
    } else if (newValue === 'Roofing') {
      setCurrentSlide(2);
    } else {
      delete values?.[otherId];
      delete values?.iamaGAFcertifiedcontractor;
    }
  };

  const handleOtherChange = (id, newValue) => {
    handleChange?.(id, newValue);
    setTimeout(() => {
      setCurrentSlide(0);
    }, 300);
  };

  const handleGafChange = (id, newValue) => {
    handleChange?.(id, newValue);
  };

  return (
    <IndustryRadioGroupContainer>
      <div className="industry-radio-group-slider">
        <div
          className={`industry-radio-group-slide slide-0 ${
            currentSlide === 0 ? 'current-slide' : ''
          }`}
        >
          <RadioGroup
            dataCy={dataCy}
            id={otherOptions.id}
            nameType={otherOptions.nameType}
            options={options}
            value={value}
            handleChange={(id, val) => onHandleChange(id, val)}
            {...otherProps}
          />
        </div>
        <div
          className={`industry-radio-group-slide slide-1 ${
            currentSlide === 1 ? 'current-slide' : ''
          }`}
        >
          <OtherOptionsContainer
            className="other-options-container"
            {...(dataCy && { 'data-cy': 'otherIndustriesStep' })}
          >
            <OtherIndustry
              id={otherId}
              label={otherLabel}
              dropdownList={otherOptions}
              onSelect={handleOtherChange}
              dataCy={dataCy}
              isSingleStepForm
            />
          </OtherOptionsContainer>
        </div>
        <div
          className={`industry-radio-group-slide slide-2 ${
            currentSlide === 2 ? 'current-slide' : ''
          }`}
        >
          <GafOptionsContainer>
            <RadioGroup
              dataCy={dataCy}
              id={'iamaGAFcertifiedcontractor'}
              nameType={'Are you a GAF certified contractor?'}
              options={[
                { value: 'yes', label: 'Yes' },
                { value: 'no', label: 'No' },
              ]}
              value={values.iamaGAFcertifiedcontractor}
              handleChange={handleGafChange}
            />
          </GafOptionsContainer>
        </div>
      </div>
    </IndustryRadioGroupContainer>
  );
};

export default IndustryRadioGroup;
